<template>
  <div >
      <vs-alert color="danger" title="User Not Found" :active.sync="user_not_found">
          No Records Found!!!
      </vs-alert>
      <div >
          <vx-card class="scroll-content" title="Employee Lists" subtitle="You may select employee to update or modify" >
               <!-- Information - Col 1 -->
                <div class="vx-row">
                   <div class="vx-col w-full mb-base">
                        <template>
                            <vs-table stripe v-model="selected" max-items="8" pagination  search :data="getAllEmployees" >
                                <template slot="thead">
                                    <vs-th width="20px"></vs-th>
                                    <vs-th>Code</vs-th>
                                    <vs-th>Last Name</vs-th>
                                    <vs-th>First Name</vs-th>
                                    <vs-th>Middle Name</vs-th>
                                    <vs-th>Status</vs-th>
                                    <vs-th>Department</vs-th>
                                </template>
                                <template slot-scope="{data}">
                                    <vs-tr :data="tr" :key="indextr" v-for="(tr, indextr) in data">
                                         <vs-td :data="data[indextr].photoUrl">
                                            <div v-if="data[indextr].photoUrl != ''"><vs-avatar :src="data[indextr].photoUrl" class="flex-shrink-0 mr-2" size="30px"  /></div>
                                            <div v-else ><vs-avatar class="rounded-full shadow-md cursor-pointer block" size="40" :text="data[indextr].fullName" :color="data[indextr].fullName.length < 12 ? 'success' : data[indextr].fullName.length <= 15 ? 'primary' : data[indextr].fullName.length <= 20 ? 'warning' : 'danger'" /></div>
   
                                            <!-- {{ data[indextr].id }} -->
                                             <!-- <vs-avatar class="rounded-full shadow-md cursor-pointer block" size="small" :src="data[indextr].photoUrl" /> -->
                                        </vs-td>
                                        <vs-td :data="data[indextr].employeeCode">
                                            {{ data[indextr].employeeCode }}
                                        </vs-td>
                                        <vs-td :data="data[indextr].lastName">
                                            {{ data[indextr].lastName }}
                                        </vs-td>
                                        <vs-td :data="data[indextr].firstName">
                                            {{ data[indextr].firstName }}
                                        </vs-td>
                                        <vs-td :data="data[indextr].middleName">
                                            {{data[indextr].middleName}}
                                        </vs-td>
                                        <vs-td >
                                            {{ data[indextr].employeeInformation.employeeStatus != null ? empStatusName(data[indextr].employeeInformation.employeeStatus).status : 'None'}}
                                            <!-- {{ empStatusName(data[indextr].employeeInformation.employeeStatus).status}} -->
                                        </vs-td>
                                        <vs-td :data="data[indextr].employeeIdentification.departmentId">
                                            {{departmentName(data[indextr].employeeIdentification.departmentId).departmentName }}
                                        </vs-td>
                                       
                                    </vs-tr>
                                </template>
                            </vs-table>
                        </template>
                    </div>
                </div>
            <div class="vx-row">
                 <div class="vx-col w-full mb-base">

                <!-- <div slot="no-body" class="tabs-container px-6 pt-6"> -->

                        <vs-tabs v-model="activeTab" class="tab-action-btn-fill-container">
                            <vs-tab label="Overtime" icon-pack="feather" icon="icon-clock">
                                <div class="tab-text">
                                    <overtime :paymentMode="paymentModeId" :userId="userId" />
                                <!-- <user-edit-tab-account class="mt-4" :data="user_data" /> -->
                                </div>
                            </vs-tab>
                            <vs-tab label="Earnings" icon-pack="feather" icon="icon-plus">
                                <div class="tab-text">
                                    <earnings :paymentMode="paymentModeId" :userId="userId" />
                                <!-- <user-edit-tab-account class="mt-4" :data="user_data" /> -->
                                </div>
                            </vs-tab>
                            <vs-tab label="Deductions" icon-pack="feather" icon="icon-minus">
                                <div class="tab-text">
                                    <deductions :paymentMode="paymentModeId" :userId="userId" />
                                <!-- <user-edit-tab-information class="mt-4" :data="user_data" /> -->
                                </div>
                            </vs-tab>
                            <vs-tab label="Loans" icon-pack="feather" icon="icon-share-2">
                                <div class="tab-text">
                                    <loans :paymentMode="paymentModeId" :userId="userId" />
                                    <!-- <loans /> -->
                                <!-- <user-edit-tab-social class="mt-4" :data="user_data" /> -->
                                </div>
                            </vs-tab>
                        </vs-tabs>

                    </div>
            </div>
          </vx-card>
          <!-- <vx-card> -->
                    
                <!-- </vx-card> -->
      </div>
    
  </div>
</template>

<script>
import Overtime from './Overtime.vue'
import Earnings from './Earnings.vue'
import Deductions from './Deductions.vue'
import Loans from './Loans.vue'

import Datepicker from 'vuejs-datepicker'
import { en, he } from 'vuejs-datepicker/src/locale'

import moment from 'moment'
import vSelect from 'vue-select'

import flatPickr from 'vue-flatpickr-component';
import 'flatpickr/dist/flatpickr.css';
 export default {
     components: {
         Overtime,
         Earnings,
         Deductions,
         Loans,
         'v-select': vSelect,
         Datepicker,
         flatPickr,
     },
    
    
    data() {
         return {
             user_data: null,
             user_not_found : false,

             selected: [],
             activeTab: 0,

             paymentModeId: 0,
             userId: '',
         }
     },
     created() {
         this.$vs.loading()
          const payload = {
                pageNumber: 1,
                pageSize: -1
             }
            this.$store.dispatch('hrms/getAllEmployee', payload)
                .then(res => {
                    this.$vs.loading.close()
                    // this.selected = this.$store.state.hrms.allEmployee[0]
                 })
                .catch(err => {
                if (err.response.status === 404) {
                    this.$vs.loading.close()
                    this.user_not_found = true
                    return
                }
                console.error(err) 
                })
        //  this.fetch_user_data()
         this.$store.dispatch('lookup/getAllDepartment').catch((err) => { console.log(err)})
         this.$store.dispatch('lookup/getAllPeriodLookup').catch((err) => { console.log(err)})
         
        
     },
     watch: {
        //  activeTab() {
        //     this.fetch_user_data()
        //  },
         selected() {
             this.paymentModeId = this.selected.employeeSalaryInformation.paymentModeId
             this.userId = this.selected.id
         }
     },
     
     computed:{
        getAllEmployees() {
            return this.$store.getters['hrms/getAllRealEmployees']()
        },
        empStatusName()  { 
            return (id) => this.$store.getters['lookup/empStatus'](id) 
        },
        departmentName() {
            return (id) => this.$store.getters['lookup/department'](id) 
        },
        
     },
     methods: {
        //  fetch_user_data() {
        //      this.user_data = this.$store.getters['hrms/getAllRealEmployees']()
        //      console.log('USER_DATA')
        //      console.log(this.user_data)
        //  }
        // getEarnings(userId) {
        //     this.employeeEarnings = this.$store.getters['payroll/getEarningsByUserId'](userId)
        //     //console.log(this.employeeEarnings)
        // },
        
    },
 }
 </script>
<style lang="scss">
#avatar-col {
  width: 10rem;
}

#page-user-view {
  table {
    td {
      vertical-align: top;
      min-width: 10px;
      padding-bottom: .8rem;
      word-break: break-all;
    }

    &:not(.permissions-table) {
      td {
        @media screen and (max-width:370px) {
          display: block;
        }
      }
    }
  }
}

// #account-info-col-1 {
//   // flex-grow: 1;
//   width: 30rem !important;
//   @media screen and (min-width:1200px) {
//     & {
//       flex-grow: unset !important;
//     }
//   }
// }


@media screen and (min-width:1201px) and (max-width:1211px),
only screen and (min-width:636px) and (max-width:991px) {
  #account-info-col-1 {
    width: calc(100% - 12rem) !important;
  }

  // #account-manage-buttons {
  //   width: 12rem !important;
  //   flex-direction: column;

  //   > button {
  //     margin-right: 0 !important;
  //     margin-bottom: 1rem;
  //   }
  // }

}

</style>

     